import { deriveScheduledItemsFromArms } from '../utils/scheduleProjection'
import { SHOW_PARTICIPANT_PROJECTION } from '../utils/constants'
import { studyDurationFromListToDays } from '../utils/studyTimelineGridUtils'

export const deriveTimelineFromState = state =>
  deriveScheduledItemsFromArms(
    state.arms,
    state.selectedArmId,
    state.instruments || [],
    state.useAbsoluteStartDate,
    state.absoluteStartDate,
    state.includeVisitCycle,
    studyDurationFromListToDays(state.studyDurationFromList),
    SHOW_PARTICIPANT_PROJECTION ? state.projectionMode || 'template' : 'template',
    SHOW_PARTICIPANT_PROJECTION ? state.participantVisits || null : null,
  )
